"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * Created by rouven on 29.03.17.
 * @class AppError
 * @classdesc  This is the main component for the graphical errors shown as soon as a javascript error occurs.
 */
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
// @ts-ignore
var react_symbol_1 = __importDefault(require("@wikom/react-symbol"));
var SingleError = function (_a) {
    var error = _a.error;
    return (react_1["default"].createElement("div", { className: "alert alert-danger", id: "page-alert-danger", role: "alert" },
        react_1["default"].createElement("button", { type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close" },
            react_1["default"].createElement(react_symbol_1["default"], { symbol: "times" })),
        react_1["default"].createElement("h4", null,
            react_1["default"].createElement(react_symbol_1["default"], { symbol: { symbol: 'ban', className: 'icon' } }),
            error.status,
            " ",
            error.name),
        react_1["default"].createElement("ul", null,
            react_1["default"].createElement("li", null, error.message))));
};
var scrollTo = function (ref) {
    window.scrollTo(0, ref.current.offsetTop);
};
var ErrorContainer = function (_a) {
    var children = _a.children;
    var selfRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () { return scrollTo(selfRef); });
    return (react_1["default"].createElement("div", { ref: selfRef }, children));
};
/**
 * Constructs an AppError UI widget, that shows errors stored in the store.
 * @constructor
 */
var AppError = function () {
    var errors = (0, react_redux_1.useSelector)(function (state) { return state.errors; }) || [];
    if (errors.length > 0) {
        return (react_1["default"].createElement(ErrorContainer, null, errors.map(function (error, i) { return react_1["default"].createElement(SingleError, { key: i, error: error }); })));
    }
    return null;
};
exports["default"] = AppError;
